import React from 'react';
import Cookies from '@synergycms_core/utils/cookies';
import Engine from '@synergycms_core/components/functional/Engine';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { compose, pipe, filter, pluck, is, length, merge, has } from "ramda";
import { get } from '@synergycms_core/utils'
import { decorateCrossDomainUrl } from '@synergycms_core/utils/crossDomain';
import { toIsoLangCode } from '@synergycms_core/utils/api';
import { connect } from 'react-redux';
import actions from './store/actions';
import { fromJS, Map } from 'immutable';
import moment from 'moment';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { enableCachePrices, contextualizeAppConfig } from "@synergycms_core/store/app/utils";

import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import Button from '@synergycms_core/components/generic/Button';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import ReactDOM from 'react-dom';
import styleFile from './app.js';
import { defaults } from "@synergycms_core/utils";
import {parseFrontLoader, toFrontendConfig} from "./start";

const AvailButton = (props) => {
  return <Button onClick={props.click} richText={{ text: '_%motor%_', translate: true, ucFirst: true }} />
};

const app = class App extends React.Component {
  static displayName = 'App';

  constructor(props) {
    super(props);
    this.state = {
      dropDown: true
    };
    this.cx = props.theme.bind();
    this.openEngineModalRef = null;
  }

  dispatchEvent = queryParams => {
    if (typeof window.CustomEvent === 'function') {

      const additionalQueryParams = {
        href: window.location.href
      };

      if (has('hotelCodes', queryParams)) {
        additionalQueryParams.hotels = queryParams.hotelCodes;
      } else if (has('hotelCode', queryParams)) {
        additionalQueryParams.id_hotel = queryParams.hotelCode;
      }

      const event = new CustomEvent('engine_search', {
        detail: {
          engine: merge(additionalQueryParams, queryParams)
        }
      });
      document.dispatchEvent(event);
    }
  };

  getOtherParams = () => {
    const queryParams = {};
    const { config } = this.props;

    // JSON SID
    if (window.json_sid) {
      queryParams.sid = window.json_sid;
    }

    // Get URL Params
    const urlParams = [
      'avail_code',
      'company_id',
      'referer_code',
      'gift_voucher',
      'id_referer',
      'promotion_code',
      'td',
      'msclkid',
      'trv_reference',
      'clickID',
      'refid',
      'gclid',
      'yclid',
      'start',
      'end',
      '_askSI',
      'dsclid'
    ];


    urlParams.forEach(urlParam => {

      // consult urlParam in cookies and get this value
      const cookieValue = Cookies.get(urlParam);
      if (cookieValue) {
        queryParams[urlParam] = cookieValue;
      }
      
      const value = new RegExp('[?&]' + urlParam + '=([^&#]*)').exec(window.location.href);
      if (length(value)) {
        queryParams[urlParam] = get(1, value);
      }

      // Comportamiento para solo motores
      if(config.data?.outer_web && sessionStorage.getItem(urlParam) && !queryParams[urlParam]){
        queryParams[urlParam] = sessionStorage.getItem(urlParam);
      }

    });

    return queryParams;
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  executeSearch = (objectParams) => {
    const { data, hotelsInfo } = this.props.config;
    let hotels = null;
    let hotelCode = null;
    const selected = objectParams.selectedSearch;
    if (data.web_type === "PORTAL" || (data.web_type === "WI" && data.group === "eurostarshotels")) {
      const country_id = !selected.country_id && !selected.code ? selected.id : null;
      const city_id = selected.country_id ? selected.id : null;

      hotelCode = selected.id && selected.code ? selected.code : null;
      if (city_id) {
        hotels = pipe(
            filter(hotel => hotel.city_id === city_id),
            pluck('code')
        )(hotelsInfo.hotels);
      } else if (country_id) {
        hotels = pipe(
            filter(hotel => hotel.country_id === country_id),
            pluck('code')
        )(hotelsInfo.hotels);
      }
    } else {
      hotelCode = data.hotel_code;
    }

    if (hotels && hotels.length === 1) {
      hotelCode = hotels[0];
      hotels = null;
    }

    console.log('objectParams.occups',objectParams.occups)

    const queryParams = merge({
      hotelCodes: hotels,
      hotelCode: hotelCode,
      city_id: (selected.country_id && !selected.code ) ? selected.id : (selected.city_id) ? selected.city_id : null,
      country_id: !selected.country_id && !selected.code ? selected.id : null,
      start: objectParams.start,
      end: objectParams.end,
      occups: objectParams.occups,
      promotion_code: objectParams.promoCode,
    }, this.getOtherParams())

    console.log('queryParams',queryParams)

    this.dispatchEvent(queryParams);

    const urlParms = ParamsParser.convertParamsToStringQuery(queryParams)

    console.log('urlParms',urlParms)

    let uri = "";
    var baseUrl = data.url && data.url.toJS ? data.url.toJS() : data.url;
    if (is(String, baseUrl)) {
      uri = baseUrl;
    } else {
      uri = baseUrl[toIsoLangCode(data.lang)];
      uri = uri ? uri : uri["en"];
    }

    //cuando hay solo un hotel, ir a su mono si enable_wi_url existe
    if(hotelCode && !!data.enable_wi_url){
      const hotelInfo = hotelsInfo?.hotels?.find(function (hotel) {
        return hotelCode === hotel.code;
      });
      if(hotelInfo){
        uri = hotelInfo.avail;
      }
    }
    console.log('uri',uri + '?' + urlParms)

    window.location.href = decorateCrossDomainUrl(uri + '?' + urlParms);
  };

  clickButtonShowEngine = e => {
    e.preventDefault();
    this.setState((state) => { return { dropDown: !this.state.dropDown}})
  }

  clickButtonShowEngineOpened = e => {
    e.preventDefault();
    if (this.openEngineModalRef) {
      this.openEngineModalRef();
    }
  }

  setOpenEngineModal = (fn) => {
    this.openEngineModalRef = fn;
  }

  getBookingDates(urlParams) {
    const sessionBookingDates = JSON.parse(sessionStorage.getItem('booking_dates') ?? '{}');
    const hasSessionDates = sessionBookingDates.start && sessionBookingDates.end;
    const urlStart = urlParams["start"] ? moment(urlParams["start"]) : null;
    const urlEnd   = urlParams["end"]   ? moment(urlParams["end"])   : null;
    const hasUrlDates = urlStart && urlEnd;

    let dateStart = null;
    let dateEnd = null;

    if (hasUrlDates) {
        dateStart = urlStart;
        dateEnd = urlEnd;

        sessionStorage.setItem(
            'booking_dates',
            JSON.stringify({
                start: urlStart.format('YYYY-MM-DD'),
                end: urlEnd.format('YYYY-MM-DD')
            })
        );

    } else if (hasSessionDates) {
        dateStart = sessionBookingDates.start;
        dateEnd = sessionBookingDates.end;
    }

    return { dateStart, dateEnd };
  }

    render() {
    const urlParams = this.getOtherParams();
    const { config, theme } = this.props;
    const { data, engineActive, pricesActive, engineType, id_button_engine, positions, hotelsInfo } = config;
    const { classes } = theme.styles

    const { dateStart, dateEnd } = this.getBookingDates(urlParams);

    // Si engineActive es false, no renderiza el motor.
    if (!engineActive) {
      return null;
    }

    const engine = <Engine
      executeSearch={this.executeSearch}
      selectSearch={config.selectSearch}
      getEngine={config.getEngine}
      onChangeCalendar={pricesActive && config.onChangeCalendar}
      params={{ ...data, hotelCode: data.hotel_code, promotion_code: urlParams["promotion_code"], start: dateStart, end: dateEnd }}
      engineModules={data.engine_modules}
      group={data.group}
      corporateLogin={data.corporate_login}
      inAvail={false}
      hotelsInfo={hotelsInfo}
      match={data.match}
      outerWeb={data.outer_web}
      limits={data.limits}
      childsInfo={data.occups_free}
      engineVisible={data.engine_visible}
      dropDownListType={data.drop_down_list_type}
      showModalView={data.show_modal_view}
      showTexts={data.show_texts}
      focusOnModalView={data.focus_on_modal_view}
      webType={data.web_type}
      lang={data.lang}
      engineSygyData={window.frontLoader && window.frontLoader['cms-engine'] ? window.frontLoader['cms-engine'] : window.engine_sygy_data}
      links={data.links}
      dateFormat={data.show_date_format}
      lastSearchsExtended={data.last_searchs_extended}
      engineType={engineType}
      setOpenEngineModal={this.setOpenEngineModal}
      extraInfo={
        {
          ...(data.hotels_catalog && {hotels_catalog: data.hotels_catalog}),
          ...(data.enable_promotion_code && {enable_promotion_code: data.enable_promotion_code}),
        }
      }
      backDrop={data.back_drop}
      shortRoomTitle={data.shortRoomTitle}
    />

    return (<>
      {!id_button_engine &&
        <>
          <div className={[theme.computedInnerStyle, this.cx({
            customPosition:positions,
            hideEngine: engineType === 'button' && this.state.dropDown })].join(' ')}>
              {engine}
          </div>

          {engineType === 'button' &&
            <div className={classes.engineBtn}>
              <AvailButton click={this.clickButtonShowEngine} />
            </div>
          }

          {engineType === 'modalButton' &&
              <div className={classes.engineBtnOuterweb}>
                <AvailButton click={this.clickButtonShowEngineOpened} />
              </div>
          }
        </>
      }

      {engineType === 'button' && id_button_engine && ReactDOM.createPortal(<>
          <AvailButton click={this.clickButtonShowEngine}/>
          {!this.state.dropDown && <div className={[theme.computedInnerStyle, this.cx(
        { customPosition:positions })].join(' ')} >
              {engine}
          </div>
          }</>, document.getElementById(id_button_engine))
      }
    </>)

  };

  componentDidMount = () => {
    const { config } = this.props;
    const { data } = config;

    if (data?.outer_web) {
      this.paramsToSessionStorage();
    } else {
      const hasDefaultDestination = data.hotel_code || data.city_id || data.country_id;

      const defaultSelected = hasDefaultDestination ? {
        id: data.hotel_id || data.city_id || data.country_id,
        code: data.hotel_code || null,
        country_id: (data.city_id && data.country_id) ? data.country_id : null,
        start: null
      } : null;

      this.props.config.selectSearch(defaultSelected);
    }
  }

  //Guardar en cookies
  paramsToCookies() {
    const queryParams = this.getOtherParams();
    var cookieParams = ["referer_code"];

    cookieParams.forEach(function (code) {
      var value = queryParams[code];
      if(value){
        Cookies.set(code, value, 30);
      }
    })
  }

  paramsToSessionStorage() {
    const queryParams = this.getOtherParams();
    var sessionStorageParams = ["referer_code", "promotion_code"];

    sessionStorageParams.forEach(function (code) {
      var value = queryParams[code];
      if(value){
        sessionStorage.setItem(code, value);
      }
    });
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeCalendar: ({ currentFirstMonth, months }) => {
      if (currentFirstMonth >= moment().startOf("day")) {
        const current = moment();
        const start = current > currentFirstMonth ? current : moment(currentFirstMonth).startOf("month");
        const end = moment(start).add(months - 1, "month").endOf("month");
        dispatch(actions.availCache.getAsync(start, end));
      }
    },
    selectSearch: (selected, range = 3) => {
      if (selected) {
        const hotelId = selected.id && selected.code ? selected.id : null;
        const selection = fromJS({
          date: selected.start,
          city_id: !hotelId && selected.country_id ? selected.id : null,
          province_id: !selected.province_id ? selected.id : null,
          country_id: !selected.country_id && !selected.code ? selected.id : null,
          hotelId: hotelId
        });
        dispatch(actions.customer.params.availCacheParams(selection));
        dispatch(actions.customer.currentCurrency.set());
      }

      dispatch(actions.availCache.getAsync(moment(), moment().add(range - 1, "month").endOf("month")));
    },
    getEngine: (hotelId, hotelCode, inAvail) => {
      let windowConfig = window.frontLoader;
      if (!windowConfig && window.engine_sygy_data) {
        windowConfig = toFrontendConfig()
      }
      windowConfig = parseFrontLoader(windowConfig);

      dispatch(actions.app.config.getEngineAsync(windowConfig, undefined, hotelCode));
    },
  };
};

const mapStateToProps = (store, ownProps) => {

  if(!store.getIn(["app", "loaded"])){
    return { 
      loaded:undefined 
    };
  }

  const hotelId = store.getIn(['customer', 'current_hotel']);
  const selectedHotelId = store.getIn(['customer', 'selected_hotel']);
  const engineConfigs = contextualizeAppConfig(store, selectedHotelId || hotelId, "engine_config");


  const childsInfo = engineConfigs.get('occups_free', null)?.toJS();
  const enableAge = (!!childsInfo && Number.isFinite(childsInfo?.baby?.start) && Number.isFinite(childsInfo?.child?.end));
  const defaultAge = engineConfigs.get('default_babies_age', null);

  let defaultChildAge = null;

  if(enableAge && Number.isFinite(defaultAge)){
    defaultChildAge = defaultAge;
  } else if(enableAge) {
    defaultChildAge = childsInfo.child.end || 11;
  }

  const lang = store.getIn(['customer', 'lang_info', 'code']) || engineConfigs.get('lang');
  const webType = store.getIn(['customer', 'web_type'])

  let hotelsInfo = null;
  if(webType === "PORTAL"){
    hotelsInfo = store.getIn(['hotels', 'hotels_info']);
    hotelsInfo = Map.isMap(hotelsInfo) ? hotelsInfo.toJS() : hotelsInfo;
  }

  let theme_values = engineConfigs.get('theme_values')
  theme_values = theme_values && Map.isMap(theme_values) ? theme_values.toJS() : theme_values;

  let data = {
    engine_active: engineConfigs.get('engine_active', true),
    price_active: enableCachePrices(store),
    limits : {
      'rooms':{
        'max': engineConfigs.get('max_rooms',10),
        'min': 1
      },
      'adults':{
        'max': engineConfigs.get('max_adults',8),
        'min': 1,
        'default': engineConfigs.get('default_adults',2),
      },
      'childs':{
        'max':  engineConfigs.get('max_childs',0),
        'min': 0,
        'default': engineConfigs.get('default_childs',0),
        'defaultAge': defaultChildAge
      }
    },
    occups: {
      "0": {
        "adults": engineConfigs.get('default_adults',2),
        "childs": engineConfigs.get('default_childs',0)
      }
    },
    outer_web : engineConfigs.get('outer_web', true),
    enable_wi_url : engineConfigs.get('enable_wi_url'),
    show_modal_view : engineConfigs.get('show_modal_view', false),
    focus_on_modal_view : engineConfigs.get('focus_on_modal_view', true),
    engine_visible : engineConfigs.get('engine_visible', true),
    engine_modules : engineConfigs.get('engine_modules', false),
    drop_down_list_type : engineConfigs.get('drop_down_list_type') ? 'nested_destinations' : null,
    theme_values : theme_values,
    theme :engineConfigs.get('theme', null),
    occups_free: enableAge && childsInfo,
    enable_promotion_code: engineConfigs.get('enable_promotion_code', false),
    hotels_catalog: webType === "PORTAL" ? engineConfigs.getIn(['hotels_catalog', lang]) : null,
    links: engineConfigs.get('links')?.toJS ? engineConfigs.get('links').toJS() : engineConfigs.get('links'),
    url: engineConfigs.get('avail_url') || engineConfigs.getIn(['url', lang]) || engineConfigs.get('url'),
    lang,
    hotel_code : engineConfigs.get('hotel_code',null),
    hotel_id: engineConfigs.get('hotel_id',null),
    city_id : engineConfigs.get('city_id',null),
    province_id : engineConfigs.get('province_id',null),
    country_id : engineConfigs.get('country_id',null),
    web_type : webType,
    group: store.get('group'),
    i18n: engineConfigs.get('i18n'),
    dropdown_position: engineConfigs.get('dropdown_position','bottom'),
    occups_dropdown_max_height: engineConfigs.get('occups_dropdown_max_height'),
    show_date_format: engineConfigs.get('show_date_format', "minified"),
    show_texts: engineConfigs.get('show_texts', true),
    back_drop: engineConfigs.get('back_drop', false),
    last_searchs_extended: engineConfigs.get('last_searchs_extended', false),
    shortRoomTitle: engineConfigs.get('shortRoomTitle', false),
    city_province_mode: engineConfigs.get('city_province_mode', "city"),
  }


  const positions = engineConfigs.get('positions', null);
  const engineType = engineConfigs.get('engine_type', 'standard');
  const id_button_engine = (engineType !== 'button') ? null : engineConfigs.get('id_button_engine', null);

  return {
    engineActive:data.engine_active,
    pricesActive:data.price_active,
    hotelsInfo,
    engineType,
    id_button_engine,
    positions,
    data:setDefaults(data)
  };
};


export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    validateAsyncComponent(mapStateToProps),
    PropertyManager([
      'pricesActive',
      'data',
      'engineActive',
      'selectSearch',
      'getEngine',
      'onChangeCalendar',
      'engineType',
      'id_button_engine',
      'positions',
      'hotelsInfo'
    ]),
    withThemeJSS({ styleFile, link: true }),
    withContent('i18n')
)(app);



const setDefaults = (engineSygyData) => {

  let result = null;

  result = defaults(engineSygyData || {}, {
    lang: "es",
    start: null,
    end:null,
  });

  return result;
};